var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_83_183",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_83_183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-12.8 0H44.8V44.8H-12.8V0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_83_183",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_83_183",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFMElEQVR4nO2dS4gdRRSGPx84iaJo8IHiA5QxCErMhERd+IggGkURdak73Uhwp1k6ySYLJSG+YmYhChKIoI6IRCUogrhQCYmPuHKRhaDRmRgGnRkzTsmRc2EYevpVp6rr3lsfHLgw3dVd/z33nKpT1T2QyWQymUwmk8lkMplMJpPpcS7wKvAn4AbUTgKvAKu7/NpfT0AIF8mkr51wJvB3AgK4SPaX9jkLzYAKPWyhYy8dIgniZU0YbkBtGnip62SYyWQymUwmE5bzgI8TGHq5yPYZcAGROQc4kEDnXSSbBFbREWcB+xIQwQW2t4CzYwm6EmcAOxMQwwWyndrHNto05oMaP5tngH8TEMYZ2SLwXI3w+Y6hzv9f+PMaieAJ4HQCIjlPWwCerDEg+ESPN6N3A98Cl1Qc+2Cf16nngMcq+rgG+GrJOWYsvZGfgKsrjr8TOJWAaK6hzQD3VPTtcuC7ZeeZsfyGfgFurDhnA/BbAuK5mjYF3FrRp7XA8YJzzWh7Y9cCPycgYpUdVxHbOo4Z1j81l5BJKLzKMxSa4Zs8LlqWPFKxb4ySuxl1hkNPNRgOuQTMcrhqhuUA/0Cf1C2aTMDMaNKJPTWmrPsSrlvIvY83bLMToUN1xhlYKCfoTOgQP0/nYaHDmhltO5hCfWShZt3CZyHDDJ+Ofg1cXNH+w8BsAJFnte0qZBy9DrhSN8qMAJcCo8BdwFZgAjiastAOOKadKGOzcX3klLZpzTUq/JcpCu0aTHNPGFzrhLYVmjHgTcsGrbxsKkJ9pM4XmiyWcXMmYH2kTt1iaISeBx6qcc3lxXWLukXyWIk8BzzQ4LrnA4dqtHtIj23CiCbLHcD7mrBli+4/6gzy+Uf923Ydfcg5QelC5B7Suf0l7e5vKMAGHaq1ecDppM4cJQkGwULk+z3v4VHgUy2+/6qVwEcanD9mXD08CNyMMaFFvg94zXqPhLJaaxwLhiL3TGa0uy13MIUWeVaPf9c4Dq6NtLpzRGeR3sQQ2XkktiJuAf6IIHLPfgc2+d50CJG3lNQ3JNvf4CnyTESRezbjK3ZMkd2Sm34euLBFuIjpyUWe3TqMxBbZLTEZhr0NPK4jB6mqlSW+FFbcj7RNkF2J7ArsjZL29xgJZbH6syuE0PO6LF/GvUY1Z6kbFzFmOIQTtnm2sdBmnJ2CJzvgi5JrWE5Gevh69kdWQscU2QFPl0yrXQChfcWWtcr1vkLHDBdOTVY3ipgIKLRvGGn0sH7Xnuw0kxcxEuANOEW09expXWFvLHQXnuy0albE3cbXWUloH8++o6nQc+qpMT3ZqcmCaBE7Igrd1rPHmwjdpciuxCsmIwvdRuz36grdtciuZFp7rMa5Eu6e1bVIK5qI/UPdRrsW2ZVMvevUNaq2g4UWW+of3oRIfK7AVqpTz9c419KT2yRIiQh9IbLzFPoKwjEeWugt2oCLZJd5hA7xur4MHbFFdsD1nslwm7FnB0mGKTMZ4Eu1Ht7JWmjfs70PJiyyUtT3bI4odNt6x+0MACMB3iRpKfJUk6JS6kwEFnq8X99pas1YwoV/821jXXMwwaWsDxlAbjJ8ustC5NMlC8l9z+6Ethu8wACzCjhsGELa2tFheN/0qNYWuhJZngi7jiFhU4ebHDcyZGw0emaxycTkNoaUUd2mEFrkw8MULsoS5K5AD/ZLmy92+XLYFFmne+EWDQRe1MmIjN0zK7Be/3/MdMs4vHcQp9UERCpqsldEJiey70JWQWRZTFZjxOTz91q0l2Ok1Nm6Cvcf8Yn1DxqPGdsAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.51d3382e65d1a1d976a28e868e821a7e.svg";
export { ForwardRef as ReactComponent };